export default "__VITE_ASSET__DU$HUJFW__"